import { AccessFunctionalityTypeEnum } from "../enums/AccessFunctionalityTypeEnum";

export interface IAccessPermission {
    functionalityType: AccessFunctionalityTypeEnum;
    functionalityTypeText?: string;
    access: number; // Enums.AccessTypeEnum bit mask;
    accessText?: string;
}

export class AccessPermission implements IAccessPermission {
    public functionalityType: AccessFunctionalityTypeEnum = AccessFunctionalityTypeEnum.None;
    public functionalityTypeText?: string;
    public access: number = 0;
    public accessText?: string;

    constructor(permission?: IAccessPermission) {
        if (permission) {
            this.functionalityType = permission.functionalityType;
            this.functionalityTypeText = permission.functionalityTypeText;
            this.access = permission.access;
            this.accessText = permission.accessText;
        }
    }

    public contains(permission: AccessPermission): boolean {
        return this.functionalityType === permission.functionalityType
            && (this.access & permission.access) === permission.access;
    }
}
